/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
function o(e, n) {
  const r = (e || "").split(".");
  let t = n;
  return r.forEach((i) => {
    t = t ? t[i] : void 0;
  }), t;
}
function a(e) {
  return e.length !== void 0;
}
export {
  o as getNestedValue,
  a as isArray
};
